
var FilterSettings = {
  values : ["must see", "family", "outdoors", "architecture", "art lovers",  "museum"],
  labelMap: {
    'must see': 'Must See',
    'family': 'Family Friendly',
    'outdoors': 'Outdoors',
    'art lovers': 'Art Lovers',
    'museum': 'Museums',
    'architecture': 'Architecture'
  }
};

module.exports = FilterSettings;



// WEBPACK FOOTER //
// ./components/constants.js